// MFAInput.tsx
import React, { useRef } from 'react';
import { FormControl, Grid, TextField } from '@mui/material';

interface MFAInputProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
  setFieldValue: (field: string, value: string) => void;
}

const MFAInput: React.FC<MFAInputProps> = ({ onChange }) => {
  const refs = useRef<(HTMLInputElement | null)[]>([]);

  return (
    <FormControl fullWidth>
      <Grid direction='row' container spacing={1}>
        {[0, 1, 2, 3, 4, 5].map((index) => (
          <Grid item md={2} key={index}>
            <TextField
              name={`code[${index}]`}
              type="text"
              onChange={(e) => onChange(e as React.ChangeEvent<HTMLInputElement>, index)}
              size='small'
              variant='outlined'
              inputRef={(ref) => refs.current[index] = ref}
            />
          </Grid>
        ))}
      </Grid>
    </FormControl>
  );
};

export default MFAInput;
